import {sort} from "../properties/sort";
import {filter} from "./properties/filter";
import {pagination} from "../properties/pagination";
import {model} from "./properties/model";
import { i18n } from '@/utils/i18n';

export const mutations = {
    SET_LIST: (state, organizations) => {
        state.list = organizations
    },
    SET_FILTER: (state,filter) => (state.filter = filter),
    SET_INVENTORY: (state,list) => state.inventory = list,
    SET_PAGINATION: (state,pagination) => (state.pagination = pagination),
    SET_SORT: (state,sort) => (state.sort = sort),
    SET_MODEL: (state,model) => {
        state.model.id = model.id;
        state.model.company_name = model.company_name;
        state.model.phone = model.phone;
        state.model.code = model.code;
        state.model.fax = model.fax;
        state.model.email = model.email;
        state.model.address = model.address;
        state.model.inn = model.inn;
        state.model.mfo = model.mfo;
        state.model.okonx = model.okonx;
        state.model.oked = model.oked;
        state.model.rkp_nds = model.rkp_nds;
        state.model.created_at = model.created_at;
        state.model.updated_at = model.updated_at;
    },
    UPDATE_COLUMN: (state, obj) => {
        state.columns[obj.key].show = obj.value
    },
    UPDATE_SORT: (state, sort) => {
        state.sort[sort.column] = sort.order
    },
    UPDATE_PAGINATION: (state, pagination) => {
        state.pagination[pagination.key] = pagination.value
    },
    EMPTY_MODEL: (state) => {
        state.model = JSON.parse( JSON.stringify( model ));
    },
    REFRESH: (state) => {
        state.filter = JSON.parse( JSON.stringify( filter ));
        state.sort = JSON.parse( JSON.stringify( sort ));
        state.pagination = JSON.parse( JSON.stringify( pagination ));
    },
    UPDATE_LANG_COLUMN: (state) => {
            state.columns.id.title = "№";
            state.columns.company_name.title = i18n.t('message.company_name');
            state.columns.phone.title = i18n.t('message.phone');
            state.columns.code.title = i18n.t('message.code');
            state.columns.fax.title = i18n.t('message.fax');
            state.columns.email.title = i18n.t('message.email');
            state.columns.address.title = i18n.t('message.address');
            state.columns.inn.title = i18n.t('message.inn');
            state.columns.mfo.title = i18n.t('message.mfo');
            state.columns.okonx.title = i18n.t('message.okonx');
            state.columns.oked.title = i18n.t('message.oked');
            state.columns.rkp_nds.title = i18n.t('message.rkp_nds');
            state.columns.created_at.title = i18n.t('message.date');
            state.columns.updated_at.title = i18n.t('message.update_date');
            state.columns.settings.title = i18n.t('message.settings');
    }
};
